// article-section.styles.ts
import styled from "styled-components";
import { colorPalette, typeScale } from "../../../../../../utils/theme";

export const FullBleed = styled.div`
  /* Break out of any centered container/col and span the viewport */
  width: 100vw;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);

  /* Prevent horizontal scrollbars caused by parent overflow settings */
  overflow: hidden;

  /* Optional: keep it aligned when a vertical scrollbar appears/disappears */
  /* box-sizing: content-box; */
`;

// article-section.styles.ts
export const ArticlesContainer = styled.div`
  padding-bottom: 82px;

  .scroll-wrapper {
    display: flex;
    align-items: center;
    position: relative;
  }

  .updates-container {
    display: flex;
    overflow-x: auto;
    scroll-behavior: smooth;
    scrollbar-width: none;

    /* 👇 Align first card under the headline, but keep full-bleed scroll */
    padding-left: calc(70px + (55vw - 50%));
    padding-right: calc(70px + (55vw - 50%));

    max-width: 100%;

    &::-webkit-scrollbar {
      display: none;
    }

    @media (max-width: 767.98px) {
      /* On mobile the Col is full width => (50vw - 50%) == 0 */
      padding-left: 16px;
      padding-right: 16px;
    }
  }

  @media (max-width: 767.98px) {
    padding-bottom: 48px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 32px;
  padding-bottom: 24px;

  @media (max-width: 767.98px) {
    padding: 24px 16px;
  }
`;

export const Title = styled.h2`
  margin: 0;
  color: ${colorPalette.primaryDark};
  ${typeScale.headingMain}

  @media (max-width: 767.98px) {
    ${typeScale.headingSMMain};
  }
`;

export const ArticleItem = styled.div`
  flex: 0 0 calc(25% - 16px); /* Allow 4 items max per row with gaps */
  margin-right: 16px;
  transform: scale(1); /* Default state */
  transition: transform 0.3s ease; /* Smooth transition */

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    transform: scale(0.98); /* Slight scale down */
    cursor: pointer;
  }

  /* Mobile: Full width */
  @media (max-width: 767.98px) {
    flex: 0 0 calc(100% - 16px); /* Full width for mobile */
    max-width: 300px;
  }

  /* Tablet to Medium Desktop: 3 items per row */
  @media (min-width: 768px) and (max-width: 1199.98px) {
    flex: 0 0 calc(33.33% - 16px);
  }
`;

export const ArticleImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;
`;

export const ArticleTitle = styled.h3`
  margin: 16px 0 8px;
  color: ${colorPalette.textMain};
  ${typeScale.headingSMMain};

  @media (max-width: 767.98px) {
    margin: 16px 0 4px;
    ${typeScale.headingXSMain};
  }
`;

export const ArticleDescription = styled.p`
  margin: 0;
  color: ${colorPalette.textDark};
  ${typeScale.bodyXS};

  @media (max-width: 767.98px) {
    ${typeScale.bodyXXS};
  }
`;

export const ScrollButton = styled.button`
  border: none;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  z-index: 5;
  top: 50%;
  transform: translateY(-50%);
  color: ${colorPalette.primaryDark};
  transition: background-color 0.2s ease;
  backdrop-filter: blur(4px);
  background: rgba(255, 255, 255, 0.8);

  &:hover {
    background: rgba(255, 255, 255, 0.5);
  }

  &.scroll-left {
    left: 4px;
  }

  &.scroll-right {
    right: 4px;
  }
`;
